import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

// Initial state for reducer
const initialState = {
  loading: false,
};

const slice = createSlice({
  name: "recommendations",
  initialState: initialState,
  reducers: {
    recommendationReset: (state) => {
      return { ...state, ...initialState };
    },

    getProfileRecommendationsRequest: (state, payload) => {
      return { ...state, loading: true };
    },
    getProfileRecommendationsSuccess: (state, { payload }) => {
      return {
        ...state,
        loading: false,
        data: _.get(payload, "data", {}),
        message: payload.message,
      };
    },
    getProfileRecommendationsFailed: (state, { payload }) => {
      return {
        ...state,
        loading: false,
        message: payload.message || "",
        errors: payload.errors || {},
      };
    },
  },
});

// Actions
export const {
  getProfileRecommendationsRequest,
  getProfileRecommendationsSuccess,
  getProfileRecommendationsFailed,
} = slice.actions;

// Reducers
export default slice.reducer;
